import React from 'react'

import { TableCell, TableHead, TableRow } from '@material-ui/core'

import HeadFilter from './headFilter'

const EnhancedTableHead = ({ headRows, useFilters, tableId, onFilterChange }) => {
  const [, setFilters] = React.useState({})

  const innerOnChange = React.useCallback(
    (fieldName, fieldValue) => {
      setFilters(prev => {
        const newValues = {
          ...prev,
          [fieldName]: fieldValue
        }

        onFilterChange(newValues)
        return newValues
      })
    },
    [onFilterChange]
  )

  return (
    <TableHead className='zr-thead'>
      <TableRow className='zr-tr'>
        {headRows.map((row, k) => (
          <TableCell
            className='zr-th'
            key={k}
            align={row.align || 'left'}
            style={
              row.width
                ? {
                    width: `${row.width}px`,
                    minWidth: `${row.width}px`,
                    maxWidth: `${row.width}px`
                  }
                : {}
            }
            padding='default'
          >
            {row.label}
          </TableCell>
        ))}
      </TableRow>
      {useFilters ? (
        <TableRow className='zr-tr'>
          {headRows.map((row, k) => (
            <React.Fragment key={k}>
              {row.filter ? (
                <TableCell className='zr-th' padding='default'>
                  <HeadFilter {...row.filter} tableId={tableId} onChange={innerOnChange} />
                </TableCell>
              ) : (
                <TableCell className='zr-th' padding='default' />
              )}
            </React.Fragment>
          ))}
        </TableRow>
      ) : null}
    </TableHead>
  )
}

export default React.memo(EnhancedTableHead)
